module.exports = __webpack_public_path__ + "img/1548406335.97b0a89b.jpg";